module.exports = __webpack_public_path__ + "static/img/Tom-Starling.578c77d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Starling.jpg
// module id = SQZ5
// module chunks = 0